import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useSWRConfig } from "swr";
import { MutationReference } from "./core/apis";
import { LayoutApplication } from "./layout/appLayout";
import { Language } from "./utils/language";

function App() {
  const { cache, mutate } = useSWRConfig();
  React.useEffect(() => MutationReference.SetReference(mutate), [mutate]);
  React.useEffect(() => ((window as any).CacheStorage = cache), [cache]);
  React.useEffect(() => Language.fetchLanguages(), []);

  return (
    <BrowserRouter>
      <LayoutApplication />
    </BrowserRouter>
  );
}

export default App;
